// extracted by mini-css-extract-plugin
module.exports = {"block":"DetailedPreview_block__wvh_8","picture":"DetailedPreview_picture__oK0gN","content":"DetailedPreview_content__i4nhb"};